import React from 'react'
import { KTSVG } from '../../../../../_metronic/helpers'
import type { LibraryApi } from '../../core/libraryApi'

interface Props {
  isOpen: boolean
  onClose: () => void
  submenuId: number
  fieldId: number
  labelName: string
  onFieldDeleted: () => void
  api: LibraryApi
}

export type { Props as DeleteFieldModalProps }

const DeleteFieldModal: React.FC<Props> = ({ onClose, isOpen, submenuId, fieldId, labelName, onFieldDeleted, api }) => {
  const handleDeleteFieldItem = async () => {
    try {
      const response = await api.deleteField(submenuId, fieldId)
      onFieldDeleted()
      onClose()
    } catch (err) {
      alert('error deleting field')
      console.error('Failed to delete field:', err)
    }
  }

  if (!isOpen) return null

  return (
    <div className='modal-overlay'>
      <div className='modal-content' onClick={(e) => e.stopPropagation()} style={{ paddingInline: '1rem' }}>
        <div className='custom-modal-header border-0 d-flex justify-content-end align-items-center'>
          <button className='close-btn' onClick={onClose}>
            <KTSVG path='/media/map/x.svg' className='svg-icon-2x' />
          </button>
        </div>

        <div className='custom-modal-body pt-0'>
          <div className='d-flex justify-content-center mb-4'>
            <KTSVG path='/media/map/exclamation.svg' className='svg-icon-4x'></KTSVG>
          </div>
          <p className='text-center'>
            Are you sure you want to delete the <strong>"{labelName || 'Field'}"</strong> field?
          </p>
          <div className='d-flex justify-content-center gap-2 mt-5'>
            <button className='btn btn_secondary' onClick={onClose}>
              No, Keep it
            </button>
            <button className='btn btn_danger' onClick={handleDeleteFieldItem}>
              Yes, Delete!
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeleteFieldModal
